// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__38ziv","boxTitle":"Qualiphy_boxTitle__10Z-g","box":"Qualiphy_box__2Yu3s","toggleWrap":"Qualiphy_toggleWrap__5K68z"};